import { inspection, updateInspection } from "../data/inspections.js";
import {
	saveImages,
	deleteImage,
	deleteDrawing,
	updateImage,
	updateDrawing,
	copyConnectedImages,
	deleteConnectedImages,
	checkConnectedImages
} from "../data/images.js";
import { navigate } from "./app.js";
import { computeParts, getNestedProperty, setNestedProperty, skippedTabs } from "../lib/helpers.js";
import { checkRelatedInspections, validateCurrentInspection } from "./validation.js";
import { applyDefaults } from "../lib/inspxValidationModule.js";
import { getDate, getTime } from "../lib/validation-helpers.js";

export const SAVE_PHOTO = "SAVE_PHOTO";
export const LOAD_INSPECTION = "LOAD_INSPECTION";
export const LOAD_REMOTE_INSPECTION = "LOAD_REMOTE_INSPECTION";

export const UNLOAD_INSPECTION = "UNLOAD_INSPECTION";
export const UPDATE_CURRENT_INSPECTION = "UPDATE_CURRENT_INSPECTION";
export const UPDATE_CURRENT_REMOTE_INSPECTION = "UPDATE_CURRENT_REMOTE_INSPECTION";
export const UPDATE_CURRENT_INSPECTION_ERROR = "UPDATE_CURRENT_INSPECTION_ERROR";
//export const UPDATE_LMD = 'UPDATE_LMD';
export const COMPLETE_INSPTECTION = "COMPLETE_INSPTECTION";
export const COMPLETE_INSPTECTION_ERROR = "COMPLETE_INSPTECTION_ERROR";

export const loadInspection = () => (dispatch, getState) => {
	let s = getState();
	let id = s.app.route.id;
	return inspection(id).then(i => {
		const promise = checkInspectionDefaults(i);
		promise.then((insp) => {
			return dispatch(loadSuccess(insp));
		});
		return promise;
	});
};

const checkInspectionDefaults = (insp) => {
	if (!insp || insp.isDefaulted === true) {
		return Promise.resolve(insp);
	}

	var copy = JSON.parse(JSON.stringify(insp));
	applyDefaults(copy.type.schema, copy);
	copy.isDefaulted = true;
	return updateInspection(copy, true).then(key => {
		return copy;
	});
};

export function getUpdateInspectionPromise() {
	return updateCurrentInspectionPromise;
}

let updateCurrentInspectionPromise = Promise.resolve();


export const updateCurrentRemoteInspection = (change) => async (dispatch, getState) => {
	let changeObj = JSON.parse(JSON.stringify(getState().inspection.remote.inspection));

	if (change.action == undefined) {
		setNestedProperty(changeObj, change.path, change.value);
	}

	if (typeof change.value === 'undefined') {
		// removes all props set to undefined, for example, { card: { p: undefined } } => { card: {} }
		changeObj = JSON.parse(JSON.stringify(changeObj));
	}

	dispatch({ type: UPDATE_CURRENT_REMOTE_INSPECTION, changeObj });
};


export const updateCurrentInspection = (change) => async (dispatch, getState) => {
	await updateCurrentInspectionPromise;
	updateCurrentInspectionPromise = new Promise((resolve) => {
		let current = (getState().inspection && getState().inspection.current)
			? getState().inspection.current
			: null;
		if (!current) {
			resolve();
			return;
		}

		let changeObj = JSON.parse(JSON.stringify(getState().inspection.current));

		const thenFunc = (key) => {
			const result = key
				? dispatch({ type: UPDATE_CURRENT_INSPECTION, changeObj, key })
				: dispatch({ type: UPDATE_CURRENT_INSPECTION_ERROR, change, key: changeObj._key });
			resolve();
			return result;
		};

		const hasConnectedImages = (changeObj, path, value) => (
			changeObj && typeof changeObj === "object" &&
			path && typeof path === "string" &&
			value && value.connected_images &&
			Object.getOwnPropertyNames(value.connected_images).length > 0);

		if (change.action != undefined) {
			switch (change.action.name) {
				case "deleteArrayItem":
					let arr = getNestedProperty(changeObj, change.path);
					let removedValue = arr.splice(change.action.index, 1)[0];

					const shouldDeleteConnectedImages = hasConnectedImages(changeObj, change.path, removedValue);
					if (shouldDeleteConnectedImages) {
						return deleteConnectedImages(changeObj, removedValue).then(thenFunc);
					}
					break;

				case "arrayItemCopy":
					setNestedProperty(changeObj, change.path, change.value);

					const shouldCopyConnectedImages = hasConnectedImages(changeObj, change.path, change.value);
					if (shouldCopyConnectedImages) {
						return copyConnectedImages(changeObj, change.value).then(thenFunc);
					}
					break;

				case "addArrayItem":
					setNestedProperty(changeObj, change.path, change.value);
					applyDefaults(changeObj.type.schema, changeObj);
					break;

				case "cancelInspection":
					cancelInspection(changeObj);
					break;
				
				default:
					break;
			}
		} else {
			setNestedProperty(changeObj, change.path, change.value);
		}

		if (typeof change.value === 'undefined') {
			// removes all props set to undefined, for example, { card: { p: undefined } } => { card: {} }
			changeObj = JSON.parse(JSON.stringify(changeObj));
		}

		return updateInspection(changeObj).then(thenFunc);
	});

	return updateCurrentInspectionPromise;
};

export const unloadInspection = () => dispatch => {
	dispatch(unload());
};

const unload = () => ({ type: UNLOAD_INSPECTION });

const loadSuccess = i => ({
	type: LOAD_INSPECTION,
	inspection: i
});

export const loadRemoteInspSuccess = i => ({
	type: LOAD_REMOTE_INSPECTION,
	data: i
});

export function savePhotos(detail) {
	return (dispatch, getState) => {
		const s = getState();
		const inspId = s.app.route.id;
		return saveImages(inspId, detail).then(() => {
			dispatch(loadInspection());
		});
	};
}

export function deletePhotoById(id) {
	return (dispatch, getState) => {
		const s = getState();
		const inspId = s.app.route.id;
		return deleteImage(id, inspId).then(() => dispatch(loadInspection()))
	};
}

export function deleteDrawingById(id) {
	return (dispatch, getState) => {
		const s = getState();
		const inspId = s.app.route.id;
		return deleteDrawing(id, inspId).then(() => dispatch(loadInspection()))
	};
}

export function updateImageById(id, updatedData) {
	return (dispatch, getState) => {
		// const s = getState();
		return updateImage(id, updatedData).then(() => {
			dispatch(loadInspection());
		});
	};
}

export function updateDrawingById(id, updatedData) {
	return (dispatch, getState) => {
		// const s = getState();
		return updateDrawing(id, updatedData).then(() => dispatch(loadInspection()))
	};
}

// export const updateLmd = (lmd) => (dispatch) => {
//     dispatch(loadInspection()).then(() =>
//         dispatch({
//             type: UPDATE_LMD,
//             lmd: lmd
//         }));
// };


export const saveRemoteInspection = () => (dispatch, getState) => {
	return dispatch(validateCurrentInspection()).then(() => {
		const state = getState();

		if (!state.validation.isInspectionValid) return;

		let changeObj = JSON.stringify(state.inspection.remote.inspection);

		return fetch(
			window.INSP.config.apiUrl + "/api/inspection/saveCorrection",
			{
				method: "post",
				headers: { Authorization: "Bearer " + state.app.token },
				body: changeObj
			}
		)
	});
};

export const completeCurrentInspection = (force = false) => (dispatch, getState) => {
	return dispatch(validateCurrentInspection()).then(() => {
		const state = getState();

		if (!state.validation.isInspectionValid) return;

		return checkConnectedImages(state.inspection.current).then(check => {
			if (!check) {
				alert('Inspectie kan niet worden afgerond, omdat één of meer afbeeldingen corrupt zijn. Check het tabblad afbeeldingen om te kijken welke afbeelding corrupt is (mogelijk witte foto). Voeg deze opnieuw toe en probeer weer af te ronden.');
				return;
			}

			return dispatch(checkRelatedInspections(force)).then(() => {
				const state = getState();
				if (!state.validation.relatedInspectionsCheck) return;

				let changeObj = JSON.parse(JSON.stringify(state.inspection.current));
				changeObj.status = "done";

				return updateInspection(changeObj).then(key => {
					if (key) {
						dispatch({ type: COMPLETE_INSPTECTION, changeObj, key });
						dispatch(navigate("/active-inspections"));
					} else {
						dispatch({
							type: COMPLETE_INSPTECTION_ERROR,
							changeObj,
							key: changeObj._key
						});
					}
				});
			});
		});
	});
};

function cancelInspection(changeObj) {
	let parts = computeParts(changeObj.type.schema);
	let requiredTaps = changeObj.type.schema.required;
	let tabs = parts.filter((p) => requiredTaps.indexOf(p.name) > -1 && skippedTabs.indexOf(p.name) === -1);
	for (const tab of tabs) {
		processPart(changeObj, tab, tab.name);
	}
	setRPSSpecificFields(changeObj);
}

function processPart(o, part, path = "") {
	if (part == null || typeof part !== 'object') return;

	let value = getNestedProperty(o, path);
	switch (true) {
		case (part.readonly):
			break;
		
		case (value === undefined && part.type === "string" && part.renderingType === "time"):
			const d = new Date();
			const t = new Date(d.getFullYear() + "-" + (d.getMonth() + 1) + "-1 " + getTime(d));
			setNestedProperty(o, path, t.toISOString());
			break;
		case (value === undefined && part.type === "string" && part.renderingType === "date"):
			setNestedProperty(o, path, getDate(new Date()));
			break;
		case (value === undefined && part.type === "string" && part.renderingType === "date-time"):
			setNestedProperty(o, path, new Date().toISOString());
			break;
		case (!value && part.type === "string" && part.renderingType === "string"):
		case (!value && part.type === "string" && part.renderingType === "multiline"):
		case (!value && part.type === "string" && part.renderingType === "barcode"):
			setNestedProperty(o, path, " ");
			break;
		case (!value && part.type === "string" && part.renderingType === "dropdown"):
		case (!value && part.type === "string" && part.renderingType === "combo"):
			setNestedProperty(o, path, part.enum[0]);
			break;	
		case (value == undefined && part.type === "integer" && part.renderingType === "integer"):
		case (value == undefined && part.type === "number" && part.renderingType === "number"):
			setNestedProperty(o, path, 0);
			break;
		case (value == undefined && part.type === "boolean" && part.renderingType === "checkbox"):
		case (value == undefined && part.type === "boolean" && part.renderingType === "toggle"):
			setNestedProperty(o, path, false);
			break;
		case (value === undefined && part.type === "object"):
			setNestedProperty(o, path, {});
			break;
		case (value === undefined && part.type === "array"):
			setNestedProperty(o, path, [{}]);
			break;
		
		default:
			break;
	}

	if (part.type === 'object') {
		let required = part.required || [];
		for (const r of required) {
			processPart(o, part.properties[r], path + '.' + r);
		}
	} else if (part.type === 'array') {
		let required = part.items.required || [];
		for (const r of required) {
			processPart(o, part.items.properties[r], path + '.0.' + r);
		}
	}
}

function setRPSSpecificFields(changeObj) {
	if (changeObj && changeObj.Inspectie_info && changeObj.Inspectie_info.inspectieInfo) {
		changeObj.Inspectie_info.inspectieInfo.Algemene_opmerkingen_project_sanering = "Afgemeld op locatie";
	}
	if (changeObj && changeObj.visueleInspectie && changeObj.visueleInspectie.Inspectiegebied &&
		changeObj.visueleInspectie.Inspectiegebied.Visuele_inspectie) {
		changeObj.visueleInspectie.Inspectiegebied.Visuele_inspectie.Afwijkende_conclusie = "Afgemeld op locatie";
	}

	changeObj._canceled = true;
}
